module.exports = __webpack_public_path__ + "img/prod.257b18e6.png";